import { memo } from 'react';

import type { CandidateListItem } from '@/api/schema';
import { Td, Tr } from '@/components/ui/Table';
import type { DateFormat } from '@/lib/dates';

import type { CandidateColumn } from '../columns';
import { renderCell } from './CandidateCells';
import styles from './CandidateRow.module.css';

/**
 * One row of the register.
 *
 * Memoised, which is worth doing here and almost nowhere else: at a hundred rows a
 * side and twenty-two columns a re-render is two thousand cells. The props are all
 * referentially stable (`columns` comes from a memo, `dateFormat` is a string, and
 * `onOpen` is a callback), so the comparison actually holds.
 */
export const CandidateRow = memo(function CandidateRow({
  candidate,
  columns,
  dateFormat,
  onOpen,
}: {
  candidate: CandidateListItem;
  columns: readonly CandidateColumn[];
  dateFormat: DateFormat;
  /** Opens the record. `Tr` handles the keyboard side once this is present. */
  onOpen: (id: string) => void;
}) {
  return (
    <Tr
      onClick={() => {
        onOpen(candidate.id);
      }}
    >
      {columns.map((column) => (
        <Td key={column.key} className={column.align === 'end' ? styles.numeric : undefined}>
          {renderCell(column.key, candidate, dateFormat)}
        </Td>
      ))}
    </Tr>
  );
});
